import { observer } from "mobx-react-lite";
import React, { useCallback } from "react";
import { ActivityTypes } from "./ActivityPricesStorage";
import { orderStorage } from "./OrderStorage";
import { IconButton, TextField } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

export default observer(function CounterCell(props: {value: number, activity: ActivityTypes}) {
  const { value, activity } = props;

  const onChange = useCallback((newValue: number) => {
    if (newValue < 0) return;
    switch (activity) {
      case ActivityTypes.VideoAnalysis: orderStorage.setAnalysisAmount(newValue); break;
      case ActivityTypes.VideoConversion: orderStorage.setConversionAmount(newValue); break;
      case ActivityTypes.HighlightDetection: orderStorage.setHighlightAmount(newValue); break;
      case ActivityTypes.VideoOcr: orderStorage.setOcrAmount(newValue); break;
      case ActivityTypes.VideoAnalysisAndSegmentation: orderStorage.setAnalysisAndSegmentationAmount(newValue); break;
      default: break;
    }
  }, [props.activity])

  if (value === -1) return <></>

  return (
    <div>
      <IconButton onClick={() => onChange(value - 1)} disabled={value<= 0}>
        <RemoveCircleIcon fontSize="small" />
      </IconButton>
      <TextField
        type="number"
        value={value}
        onChange={(e) => {
          const val = e.target.value;
          if (val === "") {
            onChange(0);
            return;
          }
          const parsed = parseInt(val, 10);
          if (!isNaN(parsed)) {
            onChange(parsed);
          }
        }}
        size="small"
        variant="standard"
        style={{ width: 50 }}
        inputProps={{ style: { textAlign: "center" } }}
      />
      <IconButton onClick={() => onChange(value + 1)}>
        <AddCircleIcon fontSize="small" />
      </IconButton>
    </div>
  );
})
